import { useEffect } from 'react';

var useScript = function useScript(url) {
  useEffect(function () {
    if (url) {
      var _document, _document$body;
      var script = document.createElement('script');
      script.setAttribute('src', url);
      script.setAttribute('async', true);
      (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : _document$body.appendChild(script);
      return function () {
        return document.body.removeChild(script);
      };
    }
    return function () {};
  }, [url]);
};

export { useScript as default };
